import {
  createSkillChainState,
  recordSkillChainSpecialFired,
  tickSkillChain,
  applySkillChainAward,
  skillChainDamageMultiplier,
  skillChainRowDrainMultiplier,
  getClassicSkillChainBoardClearWaves,
  createSpeedIdleEasterEggState,
  recordSpeedIdleEasterEggInteraction,
  tickSpeedIdleEasterEgg,
  SPEED_IDLE_EASTER_EGG_FUEL_REWARD,
} from '../../../packages/domain/src/74-steam-special-rules.mjs';

/** Bind copied earned-power policy to this instance's accepted actions and clock.
 * Paused/hidden/disposed time cannot earn fuel or spend chain duration. */
export function installSteamSpecials(r) {
  const reset = r.resetGame;
  r.resetGame = (...args) => {
    r.game.skillChain = createSkillChainState();
    r.game.speedIdleEasterEgg = createSpeedIdleEasterEggState();
    return reset(...args);
  };
  r.chainAward = (amount) => applySkillChainAward(amount, r.game.skillChain);
  r.chainDamage = (damage) => damage * skillChainDamageMultiplier(r.game.skillChain);
  r.speedRowInterval = () =>
    Math.max(
      0.16,
      r.SPEED_QUEUED_ROW_INTERVAL_SECONDS / skillChainRowDrainMultiplier(r.game.skillChain),
    );
  r.recordSpeedIdleInteraction = (options = {}) => {
    if (r.game.mode === 'speed')
      r.game.speedIdleEasterEgg = recordSpeedIdleEasterEggInteraction(
        r.game.speedIdleEasterEgg,
        options,
      );
  };
  r.tickChain = (dt) => tickSkillChain(r.game.skillChain, dt);
  r.tickIdleCache = (dt) => {
    const result = tickSpeedIdleEasterEgg(r.game.speedIdleEasterEgg, {
      mode: r.game.mode,
      status: r.game.status,
      dt,
    });
    r.game.speedIdleEasterEgg = result.state;
    if (!result.shouldGrant) return;
    r.game.neutronFuel += SPEED_IDLE_EASTER_EGG_FUEL_REWARD;
    r.addFloater(r.launcher.x, r.launcher.y - 110, '+999 SPECIAL FUEL', '#fff4c2', {
      scale: 1.7,
      life: 1.8,
    });
    r.syncHud({ force: true });
  };
  r.recordSpecialChain = () => {
    const event = recordSkillChainSpecialFired(r.game.skillChain, { mode: r.game.mode });
    r.game.modeTimerRemaining += event.speedBonusSeconds;
    if (event.speedBonusSeconds && r.game.speedQueuedRows > 0)
      r.game.speedQueuedRowTimer = Math.max(r.game.speedQueuedRowTimer, r.speedRowInterval());
    if (event.timedPressureReliefSeconds)
      r.game.timedRowAdvanceElapsed = Math.max(
        0,
        r.game.timedRowAdvanceElapsed - event.timedPressureReliefSeconds,
      );
    r.addFloater(
      r.launcher.x,
      r.launcher.y - 75,
      event.chained ? `CHAIN ×${event.multiplier}` : 'FIRE AGAIN · 5s',
      '#ffe777',
      { life: 1.5 },
    );
  };
  r.accelerateClassicChain = () => {
    const waves = getClassicSkillChainBoardClearWaves(r.game.skillChain, r.game.mode);
    for (let i = 1; i < waves && r.game.status !== 'gameover'; i++)
      r.advanceRoundAfterVolley({ force: true });
  };
}
